import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export const ProtectedRoute = ({ roles, children }) => {
  const { user, ready } = useAuth();
  if (!ready) {
    return (
      <div className="min-h-[60vh] flex items-center justify-center text-[#5c5a56]">Loading…</div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to="/" replace />;
  return children;
};
